import React from "react";
import { Form, Spinner } from "react-bootstrap";

/**
 * Reusable photo upload component with loading spinner and preview.
 */
const PhotoUpload = ({ uploading, preview, disabled, onChange, label }) => {
  return (
    <Form.Group>
      {label && <Form.Label>{label}</Form.Label>}
      <div className="d-flex align-items-center gap-3">
        <div className="flex-grow-1">
          <Form.Control
            type="file"
            accept="image/*"
            disabled={disabled || uploading}
            onChange={(e) => {
              const file = e.currentTarget.files[0];
              if (file) onChange(file);
            }}
          />
        </div>
        {uploading && (
          <div className="d-flex align-items-center gap-2">
            <Spinner animation="border" size="sm" variant="primary" />
            <span className="text-muted small">Uploading...</span>
          </div>
        )}
      </div>
      {preview && !uploading && (
        <div className="mt-2">
          <img
            src={preview}
            alt="Preview"
            style={{
              maxWidth: "120px",
              maxHeight: "120px",
              objectFit: "cover",
              borderRadius: "8px",
              border: "1px solid #dee2e6",
            }}
          />
        </div>
      )}
    </Form.Group>
  );
};

export default PhotoUpload;
